module.exports = __webpack_public_path__ + "static/media/index.736d18d6.png";